import React, { useState, useEffect } from "react";
import { baseURL } from "../../App";
import "./admin.css";
import axios from "axios";
import Cookies from "js-cookie";
import { FaTrash, FaEdit, FaSave } from "react-icons/fa";

const ExperienceAdmin = () => {
  const API_URL = `${baseURL}/api/experience`;
  const clearForm = {
    categoryEn: "",
    categoryFr: "",
    startDate: "",
    skills: [],
    descriptionEn: "",
    descriptionFr: "",
  };
  const clearSkill = { nameEn: "", levelEn: "", nameFr: "", levelFr: "" };
  const [experienceData, setExperienceData] = useState([]);
  const [newExperience, setNewExperience] = useState(clearForm);
  const [newSkill, setNewSkill] = useState(clearSkill);
  const [editingExperience, setEditingExperience] = useState(null);
  const [editingSkillIndex, setEditingSkillIndex] = useState(-1);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const token = Cookies.get("token");

  useEffect(() => {
    const fetchExperienceData = async () => {
      try {
        const response = await axios.get(API_URL, { withCredentials: true });
        setExperienceData(response.data);
      } catch (err) {
        console.error("Error fetching Experience data:", err);
        setConfirmationMessage("Error fetching data. Please try again later.");
      }
    };

    fetchExperienceData();
  }, [API_URL]);

  const handleChange = (e) => {
    setNewExperience({ ...newExperience, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (event) => {
    const selectedId = event.target.value;
    if (selectedId === "new") {
      setNewExperience(clearForm);
      setEditingExperience(null);
      setEditingSkillIndex(-1);
      setNewSkill(clearSkill);
    } else {
      const selectedExperience = experienceData.find((exp) => exp._id === selectedId);
      if (selectedExperience) {
        setNewExperience({ ...selectedExperience });
        setEditingExperience(selectedExperience);
        setNewSkill(clearSkill);
      }
    }
  };

  const handleCreate = async () => {
    try {
      const { startDate, ...rest } = newExperience;
      const formattedStartDate = startDate ? new Date(startDate).toISOString() : null;
      const response = await axios.post(
        API_URL,
        { ...rest, startDate: formattedStartDate },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      setExperienceData([...experienceData, response.data]);
      setNewExperience(clearForm);
      setConfirmationMessage("Experience created successfully!");
    } catch (error) {
      console.error("Error creating experience:", error);
      setConfirmationMessage(error?.response?.data?.message || "Error creating experience.");
    }
  };

  const handleUpdate = async () => {
    const formatDate = (dateString) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };
    try {
      const { startDate, ...rest } = newExperience;
      const formattedStartDate = startDate ? formatDate(startDate) : null;
      alert(formattedStartDate);
      const response = await axios.put(
        `${API_URL}/${newExperience._id}`,
        { ...rest, startDate: formattedStartDate },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      // Update the experienceData state with the updated experience from the server
      setExperienceData((prevData) =>
        prevData.map((experience) =>
          experience._id === newExperience._id ? response.data : experience
        )
      );

      setConfirmationMessage("Experience updated successfully!");
    } catch (error) {
      console.error("Error updating experience:", error);
      setConfirmationMessage(error?.response?.data?.message || "Error updating experience.");
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/${newExperience._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setExperienceData((prevData) =>
        prevData.filter((experience) => experience._id !== newExperience._id)
      );
      setNewExperience(clearForm); // Reset the form after deletion
      setConfirmationMessage("Experience deleted successfully!");
    } catch (err) {
      console.error("Error deleting experience:", err);
      setConfirmationMessage(err?.response?.data?.message || "Error deleting experience.");
    }
  };

  const handleAddSkill = () => {
    if (
      newSkill.nameEn.trim() === "" ||
      newSkill.nameFr.trim() === "" ||
      newSkill.levelEn.trim() === "" ||
      newSkill.levelFr.trim() === ""
    ) {
      setConfirmationMessage("Please fill in all skill fields.");
      return;
    }
    setNewExperience((prev) => ({ ...prev, skills: [...prev.skills, newSkill] }));
    setNewSkill(clearSkill);
  };

  const handleEditSkill = (index) => {
    setNewSkill(newExperience.skills[index]);
    setEditingSkillIndex(index);
  };

  const handleSaveSkill = () => {
    if (editingSkillIndex !== -1) {
      const updatedSkills = [...newExperience.skills];
      updatedSkills[editingSkillIndex] = newSkill;
      setNewExperience((prev) => ({ ...prev, skills: updatedSkills }));
      setEditingSkillIndex(-1);
      setNewSkill(clearSkill);
    }
  };

  const handleRemoveSkill = (index) => {
    const updatedSkills = newExperience.skills.filter((_, i) => i !== index);
    setNewExperience((prev) => ({ ...prev, skills: updatedSkills }));
  };

  return (
    <div className="admin-section">
      <h2>Experience Management</h2>

      {/* Dropdown for selecting or creating new */}
      <select
        className="select-item"
        onChange={handleSelectChange}
        value={newExperience._id || "new"}
      >
        <option className="select-item__option" value="new">
          New
        </option>
        {experienceData.map((exp) => (
          <option className="select-item__option" key={exp._id} value={exp._id}>
            {exp.categoryEn}
          </option>
        ))}
      </select>

      <form onSubmit={(e) => e.preventDefault()}>
        {/* Input fields */}
        <input
          type="date"
          name="startDate"
          placeholder="Start Date"
          value={newExperience.startDate}
          onChange={handleChange}
        />
        <input
          type="text"
          name="categoryEn"
          placeholder="Category (EN)"
          value={newExperience.categoryEn}
          onChange={handleChange}
        />
        <input
          type="text"
          name="categoryFr"
          placeholder="Category (FR)"
          value={newExperience.categoryFr}
          onChange={handleChange}
        />
        <textarea
          name="descriptionEn"
          placeholder="Description (EN)"
          value={newExperience.descriptionEn}
          onChange={handleChange}
          rows="6"
        />
        <textarea
          name="descriptionFr"
          placeholder="Description (FR)"
          value={newExperience.descriptionFr}
          onChange={handleChange}
          rows="6"
        />

        <h3>Skills</h3>

        {/* Display/Edit existing skills */}
        {newExperience.skills.map((skill, index) => (
          <div key={index}>
            {editingSkillIndex === index ? ( // Edit form
              <>
                <input
                  type="text"
                  placeholder="Skill (EN)"
                  value={newSkill.nameEn}
                  onChange={(e) => setNewSkill((prev) => ({ ...prev, nameEn: e.target.value }))}
                />
                <input
                  type="text"
                  placeholder="Level (EN)"
                  value={newSkill.levelEn}
                  onChange={(e) => setNewSkill((prev) => ({ ...prev, levelEn: e.target.value }))}
                />
                <input
                  type="text"
                  placeholder="Skill (FR)"
                  value={newSkill.nameFr}
                  onChange={(e) => setNewSkill((prev) => ({ ...prev, nameFr: e.target.value }))}
                />
                <input
                  type="text"
                  placeholder="Level (FR)"
                  value={newSkill.levelFr}
                  onChange={(e) => setNewSkill((prev) => ({ ...prev, levelFr: e.target.value }))}
                />
                <FaSave onClick={handleSaveSkill} />
              </>
            ) : (
              // Display skill
              <>
                <span>
                  {skill.nameEn} ({skill.levelEn}) / {skill.nameFr} ({skill.levelFr})
                </span>
                <FaEdit onClick={() => handleEditSkill(index)} />
                <FaTrash onClick={() => handleRemoveSkill(index)} />
              </>
            )}
          </div>
        ))}

        {/* Add new skill input */}
        {editingSkillIndex === -1 && (
          <div>
            <input
              type="text"
              placeholder="Skill (EN)"
              value={newSkill.nameEn}
              onChange={(e) => setNewSkill((prev) => ({ ...prev, nameEn: e.target.value }))}
            />
            <input
              type="text"
              placeholder="Level (EN)"
              value={newSkill.levelEn}
              onChange={(e) => setNewSkill((prev) => ({ ...prev, levelEn: e.target.value }))}
            />
            <input
              type="text"
              placeholder="Skill (FR)"
              value={newSkill.nameFr}
              onChange={(e) => setNewSkill((prev) => ({ ...prev, nameFr: e.target.value }))}
            />
            <input
              type="text"
              placeholder="Level (FR)"
              value={newSkill.levelFr}
              onChange={(e) => setNewSkill((prev) => ({ ...prev, levelFr: e.target.value }))}
            />
            <button className="btn btnSecondary" type="button" onClick={handleAddSkill}>
              Add Skill
            </button>
          </div>
        )}

        <div className="btn-actions">
          <button
            type="button"
            className="btn btnPrimary"
            onClick={editingExperience ? handleUpdate : handleCreate}
          >
            {editingExperience ? "Update Experience" : "Create Experience"}
          </button>
          <button
            type="button"
            onClick={handleDelete}
            disabled={!editingExperience}
            className="btn btnDanger"
          >
            Delete experience
          </button>
        </div>
      </form>

      {confirmationMessage && <div className="confirmation-message">{confirmationMessage}</div>}
    </div>
  );
};

export default ExperienceAdmin;
